const flexCollarSlide = {
  displayField: 'header',
  name: 'Flex Collar Slide',
  description: 'Slides for Flex Collar',
  fields: [
    {
      id: 'header',
      name: 'header',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'img',
      name: 'img',
      type: 'Link',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'url',
      name: 'url',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'flexCollarSlide',
    version: 6,
    updatedAt: '2023-08-02T21:58:43.508Z'
  }
};
export default flexCollarSlide;